import React from 'react';
import PropTypes from 'prop-types';
import { FormattedDate, FormattedMessage } from 'react-intl';
import Button from '../Button';
import Grid from '../Grid';
import Image from '../Image';
import SmartFormattedRelativeTime from '../SmartFormattedRelativeTime';
import heDefault from './heDefault.png';
import messages from './messages';
import './styles.css';

const NotificationsRequestsResults = ({ showSideBar, repVisitsEvent }) => (
  <Grid as="ul" data-cy="repvisits-notifications-requests-list" styleName="notification-grid">
    <Grid.Row as="li" styleName="notification-row">
      <Grid.Column>
        <div styleName="grey caps" data-cy="repvisits-requests-time-left-status">
          <SmartFormattedRelativeTime value={repVisitsEvent.dateRegistered} />&nbsp;&#183;&nbsp;
          <FormattedMessage {...messages.requestsWaitingForConfirmation} />
        </div>
        <div>
          {repVisitsEvent.collegeFairId && <FormattedMessage {...messages.requestsYourCFRequest} />}
          {repVisitsEvent.appointmentId && (
            <React.Fragment>
              <FormattedMessage {...messages.requestsYourVisitRequestPart1} />
              <b>{repVisitsEvent.chosenVisitLocationType === 'VIRTUAL' ? 'virtual' : 'in-person'}</b>
              <FormattedMessage {...messages.requestsYourVisitRequestPart2} />
            </React.Fragment>
          )}
          &nbsp;
          <strong>
            <FormattedMessage {...messages.requestsSent} />
          </strong>:
        </div>
      </Grid.Column>
    </Grid.Row>
    <Grid.Row as="li" styleName="notification-row">
      <Grid.Column width={2}>
        <Image src={heDefault} centered alt="" />
      </Grid.Column>
      <Grid.Column width={14}>
        <h5 data-cy="repvisits-requests-highschool-name" styleName="grey highschool-name">{repVisitsEvent.highSchool.name}</h5>
        <div styleName="grey" data-cy="repvisits-requests-highschool-address">{`${repVisitsEvent.highSchool.address.field_hs_elna_city},
                              ${repVisitsEvent.highSchool.address.field_hs_elna_state_latest}`}
        </div>
        <div styleName="grey" data-cy="repvisits-requests-time">
          <FormattedDate value={`${repVisitsEvent.date}T12:00:00`} weekday="long" year="numeric" month="long" day="numeric" />
          &nbsp;at&nbsp;
          {repVisitsEvent.startTime}
        </div>
        <div>
          <Button basic size="small" onClick={() => showSideBar(repVisitsEvent)}>
            <FormattedMessage {...messages.requestsViewFullDetails} />
          </Button>
        </div>
      </Grid.Column>
    </Grid.Row>
  </Grid>
);

NotificationsRequestsResults.propTypes = {
  showSideBar: PropTypes.func.isRequired,
  repVisitsEvent: PropTypes.object.isRequired,
};

export default NotificationsRequestsResults;
